/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : REPORTS : LIBRARY : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	library: {
		'& .page-details': {
			marginTop: pxToEm(40)
		},
		'&.processing-true': {
			'& .button:not(.processing-true)': { extend: disable },
			'& .link:not(.processing-true)': { extend: disable }
		}
	}
});